import ScalarIconMagicWand_vue_vue_type_script_setup_true_lang_default from "./ScalarIconMagicWand.vue.script.js";
//#region src/components/ScalarIconMagicWand.vue
var ScalarIconMagicWand_default = ScalarIconMagicWand_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconMagicWand_default as default };

//# sourceMappingURL=ScalarIconMagicWand.js.map